import { Button } from '@/ui'
import { DeviceWidth, useIsDeviceWidth } from '@/utils/deviceWidthHelpers'

interface SignupFooterProps {
  onBack?: () => void
  onContinue?: () => void
  continueDisabled?: boolean
  continueLoading?: boolean
  continueText?: string
  continueId?: string
  backText?: string
}

export const SignupFooter = ({
  onBack,
  onContinue,
  continueDisabled,
  continueLoading,
  continueText = 'Continue',
  continueId,
  backText = 'Back',
}: SignupFooterProps) => {
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)

  if (isMobile) {
    return (
      <div className="flex flex-col gap-4 w-full">
        {onContinue && (
          <Button
            onClick={onContinue}
            disabled={continueDisabled}
            loading={continueLoading}
            id={continueId}
            className="w-full"
          >
            {continueText}
          </Button>
        )}
        {onBack && (
          <Button variant="secondary" onClick={onBack} className="w-full">
            {backText}
          </Button>
        )}
      </div>
    )
  }

  return (
    <div className="flex justify-between items-center w-full">
      {onBack ? (
        <Button variant="secondary" onClick={onBack}>
          {backText}
        </Button>
      ) : (
        <div />
      )}
      {onContinue && (
        <Button
          onClick={onContinue}
          disabled={continueDisabled}
          loading={continueLoading}
          id={continueId}
        >
          {continueText}
        </Button>
      )}
    </div>
  )
}
